import {
    Button,
    CircularProgress,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import {
    IconEdit,
    IconListCheck,
    IconFlask,
    // IconExternalLink
} from "@tabler/icons-react";
import { useTheme } from "@mui/system";
import SubCard from "ui-component/cards/SubCard";
import {
    // Link,
    useParams
} from "react-router-dom";
import {
    labRecordDetailsErrorClear,
    getLabRecordDetails,
    closeLabRecordEditDialog,
    openLabRecordEditDialog,
} from "store/app/lab-management/lab-records/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import 'pure-react-carousel/dist/react-carousel.es.css';
import moment from "moment";
import EditLabRecords from "./edit";
// import Chip from "ui-component/extended/Chip";

const LabRecordDetails = (props) => {
    const { errorMessage, isPending, resetPasswordErrorMessage, labRecordDetails, isLabRecordEditDialogOpen, userProfile } = props;
    const { farmRecordIndex, farmName, technicalManagerUserName, technicalManagerUserEmail, customerName, customerEmail, submittedUserEmail,
        submittedUserName, inspectionDate, submittedTimeStamp, location, regionName, stateName, districtName, age, anticoccidial, agp, probiotic, labRecordsIndex, observation,
        reportName } = labRecordDetails || {};
    const { userRoleName } = userProfile || {};
    const params = useParams();
    const { id } = params || {};

    useEffect(() => {
        props.getLabRecordDetails(id);
        props.labRecordDetailsErrorClear();
    }, [id])

    const theme = useTheme();

    const handleLabRecordEditOpen = () => {
        props.openLabRecordEditDialog();
    }

    const handleLabRecordEditClose = () => {
        props.closeLabRecordEditDialog();
    }
    return (
        <>
            <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SubCard sx={{ p: 1.5, pl: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h4">Lab Record Details</Typography>
                        {(!errorMessage && (userRoleName === "Lab Admin" || userRoleName === "Lab User")) &&
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleLabRecordEditOpen}
                                startIcon={<IconEdit />}
                            >
                                Edit Lab Records
                            </Button>}
                    </SubCard>
                </Grid>
                {errorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={errorMessage} />
                    </Grid>
                }
                {resetPasswordErrorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={`Reset Password: ${resetPasswordErrorMessage}`} />
                    </Grid>
                }
            </Grid>
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <Grid container>
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                    <IconListCheck color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Farm Record Info
                                    </Typography>
                                </Grid>
                            </Grid>
                            <TableContainer sx={{ pl: 3, }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Farm Record No.</TableCell>
                                            <TableCell>{farmRecordIndex || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Farm Name</TableCell>
                                            <TableCell>{farmName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Technical Manager Name</TableCell>
                                            <TableCell>{technicalManagerUserName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Technical Manager Email</TableCell>
                                            <TableCell>{technicalManagerUserEmail || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Customer Name</TableCell>
                                            <TableCell>{customerName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Customer Email</TableCell>
                                            <TableCell>{customerEmail || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Submitted User Name</TableCell>
                                            <TableCell>{submittedUserName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Submitted User Email</TableCell>
                                            <TableCell>{submittedUserEmail || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Inspection Date</TableCell>
                                            <TableCell>{inspectionDate ? moment(inspectionDate).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Submitted Date</TableCell>
                                            <TableCell>{submittedTimeStamp ? moment(submittedTimeStamp).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Location</TableCell>
                                            <TableCell>{location || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Region Name</TableCell>
                                            <TableCell>{regionName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> State/Export</TableCell>
                                            <TableCell>{stateName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> District</TableCell>
                                            <TableCell>{districtName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> Age</TableCell>
                                            <TableCell>{age || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Anticoccidial</TableCell>
                                            <TableCell>{anticoccidial || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>AGP</TableCell>
                                            <TableCell>{agp || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Probiotic</TableCell>
                                            <TableCell>{probiotic || "N/A"}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                        <MainCard sx={{ mt: 1, ml: 1 }}>
                            <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconFlask color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Lab Record Info
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3 }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>Lab Record No.</TableCell>
                                            <TableCell>{labRecordsIndex || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>Report Name</TableCell>
                                            <TableCell>{reportName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>Observation</TableCell>
                                            <TableCell sx={{ textAlign: "justify" }}>{observation || "N/A"}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                </Grid >
            }

            <EditLabRecords
                open={isLabRecordEditDialogOpen}
                onClose={handleLabRecordEditClose}
                labRecordDetails={labRecordDetails}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    labRecordDetails: state.labRecords.labRecordDetails,
    isPending: state.labRecords.isLabRecordDetailsPending,
    errorMessage: state.labRecords.labRecordDetailsErrorMessage,
    isLabRecordEditDialogOpen: state.labRecords.isLabRecordEditDialogOpen,
    userProfile: state.login.userProfile,
})

const mapDispatchToProps = (dispatch) => ({
    getLabRecordDetails: (id) => dispatch(getLabRecordDetails(id)),
    labRecordDetailsErrorClear: (id) => dispatch(labRecordDetailsErrorClear(id)),
    openLabRecordEditDialog: (id) => dispatch(openLabRecordEditDialog(id)),
    closeLabRecordEditDialog: () => dispatch(closeLabRecordEditDialog()),
})

export default connect(mapStateToProps, mapDispatchToProps)(LabRecordDetails);